module.exports = __webpack_public_path__ + "static/media/removeIconRedWithBg.13bd5072.png";